import React from 'react';
import { ALL_MISSING_FROM_POOL_MESSAGE, NO_PROPOSED_MESSAGE, RANK_RENUMBER_NOTE } from './candidateVisibility';

/**
 * 求職者に提案する求人の件数 (DP-M-017。画面レイアウト_SCR-M-001.md §4.2・§5.2 No.7・§7.2、Issue #992)。
 *
 * 「求職者に提案する求人: N 件（全 M 件）」を常に出す。新しい推薦結果では設定を引き継がないため、
 * 外した求人が PDF に戻っていることに気づけるようにする (丹羽様のご判断 2026-10-04)。
 * N < M のときだけ、PDF と画面で順位がずれることを補足で 1 回だけ伝える。N = 0 のときは、
 * 補足の代わりに PDF エクスポートを押せない理由を出す。M = 0 (推薦候補がすべて求人プールに無い求人の
 * 枠。枠は数えない。Issue #883) のときは、チェックできる求人が無いため別の理由を出す。
 * 件数の色は N < M でも変えない (減らしたのは担当者の選択で、警告ではない)。
 * 件数の変化と押せない理由を読み上げるため、role="status" の領域に置く。
 *
 * @param {{visible: number, total: number}} props visible は載せる候補の数、total は推薦候補の数
 */
function CandidateVisibleCount({ visible, total }) {
    let note = null;
    if (total === 0) {
        note = <span className="matching-candidate-count-reason">{ALL_MISSING_FROM_POOL_MESSAGE}</span>;
    } else if (visible === 0) {
        note = <span className="matching-candidate-count-reason">{NO_PROPOSED_MESSAGE}</span>;
    } else if (visible < total) {
        note = <span className="matching-candidate-count-note">{RANK_RENUMBER_NOTE}</span>;
    }
    return (
        <p className="matching-candidate-count" role="status">
            <span className="matching-candidate-count-value">
                求職者に提案する求人: {visible} 件（全 {total} 件）
            </span>
            {note}
        </p>
    );
}

export default CandidateVisibleCount;
